import { Route, Navigate } from 'react-router'
import { RoutesWithNotFound } from 'entities/ExportRouters/ui/RoutesWithNotFound'
import { NewInboxRoutes } from 'pages/settings/pages/inboxes/route/type'
import { BuyNumberAccessLayout } from 'pages/settings/pages/inboxes/pages/id/pages/numbers/pages/BuyNumber/layout/BuyNumberAccessLayout'
import { BuyNumberStepsLayout } from 'pages/settings/pages/inboxes/pages/id/pages/numbers/pages/BuyNumber/layout/BuyNumberStepsLayout'
import { ChooseNumber } from 'pages/settings/pages/inboxes/pages/id/pages/numbers/pages/BuyNumber/ui/ChooseNumber/ChooseNumber'
import { Payment } from 'pages/settings/pages/inboxes/pages/id/pages/numbers/pages/BuyNumber/ui/Payment/Payment'

export const BuyNumberStepsRouter = () => {
  return (
    <RoutesWithNotFound>
      <Route element={<BuyNumberAccessLayout />}>
        <Route element={<BuyNumberStepsLayout />}>
          <Route index element={<Navigate to={NewInboxRoutes.chooseNumber} replace />} />
          <Route path={NewInboxRoutes.chooseNumber} element={<ChooseNumber />} />
          <Route path={NewInboxRoutes.payment} element={<Payment />} />
        </Route>
      </Route>
    </RoutesWithNotFound>
  )
}
